import { State } from 'src/types'
import { normalWristBelt } from './normalWristBelt'

export const wristBeltDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isThumbIntegrated = state.baseModel.productNumber === 'APL-UR003+' || state?.beltType?.value === 'thumbIntegrated'
  if (!isThumbIntegrated) {
    normalWristBelt(ctx, state.listBelt.color, state.stitch.color)
  }
}
